import * as t from "io-ts";
import nullable from "./nullable";
export const placeT = t.intersection([
    t.strict({
        address: nullable(t.string),
        postcode: nullable(t.string),
        city: nullable(t.string),
        country: nullable(t.string),
        placeName: nullable(t.string),
        coord: t.strict({
            lon: t.number,
            lat: t.number,
        }),
    }),
    t.partial({
        googlePlaceId: t.string,
        hereMapsId: t.string,
    }),
]);
//# sourceMappingURL=place.js.map